import React from 'react';
import { useParams } from 'react-router-dom';
import { KidStoriesData } from './data/KidStoriesData';
import KidStoryCard from './KidStoryCard';
import styles from './css/KidStoriesFullPage.module.css';

const KidStoriesFullPage = () => {
  const { category } = useParams(); // Get the dynamic parameter from the URL

  // Filter stories based on the category (assuming category exists in KidStoriesData)
  const filteredStories = category
    ? KidStoriesData.filter(story => story.category.toLowerCase() === category.toLowerCase())
    : KidStoriesData; // Show all if no category is provided

  return (
    <div className={styles.kidStoriesContainer}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.fullPageTitle}>Kid Stories - {category ? category.toUpperCase() : 'All'}</h2>
      </div>
      <div className={styles.cardGrid}>
        {filteredStories.map((story) => (
          <KidStoryCard key={story.id} story={story} />
        ))}
      </div>
    </div>
  );
};

export default KidStoriesFullPage;
